// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_GetBulkStatisticsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /mensagens_programadas_lote/get_bulk_statistics
 *
 * Optional date range filter for bulk messaging statistics.
 */
import { registerContract } from './validate'

export interface MensagensProgramadasLote_GetBulkStatisticsInput {
date_from?: string
date_to?: string
}

registerContract('MensagensProgramadasLote_GetBulkStatisticsInput', {
  date_from: { type: 'string',  required: false },
  date_to:   { type: 'string',  required: false },
})
